/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUpdateSigningKeyRequestFromJSON(json) {
    return StreemApiUpdateSigningKeyRequestFromJSONTyped(json, false);
}
export function StreemApiUpdateSigningKeyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'expiresAt': !exists(json, 'expires_at') ? undefined : (new Date(json['expires_at'])),
        'clearExpiresAt': !exists(json, 'clear_expires_at') ? undefined : json['clear_expires_at'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}
export function StreemApiUpdateSigningKeyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'expires_at': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
        'clear_expires_at': value.clearExpiresAt,
        'label': value.label,
    };
}
//# sourceMappingURL=StreemApiUpdateSigningKeyRequest.js.map